import React from 'react';
import ProductItemTitles from '../Shared/ProductItemTitles';
import {isMobile} from 'react-device-detect';
import {ColumnHtml, ColumnTwoPartsHtml, ColumnHtmlWithIcon} from '../Shared/sharedHtmlComponents';
import {productStatus, productsTypes} from '../productsAndServicesBlockSlice';
import ProductStatus from '../Shared/ProductStatus';
import CategoryName from '../Shared/CategoryName';
const MapaItem = (props) => {
  const itemTitles = ['מספר קו', 'חבילה', 'כתובת התקנה'];
  const widthList = ['20', '30', '50'];

  return (
    <div className={`productAndServicesItemContainer ${props.type}`}>
      <CategoryName
        title={'טלפון ביתי'}
        imageName={`${isMobile ? 'mobile' : 'mobile-desc'}`}
        goToAction={props.goToAction}
        actions={props.mapaActions}
        allActionButtonText={props.allActionButtonText}
        goToAllAction={props.goToAllAction}
        type={productsTypes.MAPA}
      />
      {!isMobile && <ProductItemTitles titlesList={itemTitles} widthList={widthList} />}
      {props.mapaItems?.map((mapaItem, index) => {
        const ban = mapaItem.ban;
        const subscriberNo = mapaItem.subscriberNumber;
        const status =
          mapaItem.productStatus == productStatus.BUSINESS ||
          mapaItem.productStatus == productStatus.CANCELLED ||
          mapaItem.productStatus == productStatus.SUSPENDED
            ? mapaItem.productStatus
            : null;
        return (
          <div key={index}>
            {!isMobile ? (
              <>
                <div className='productAndServicesItemContainer_content_wrapper d-flex'>
                  {status && <ProductStatus status={status} />}
                  <ColumnHtml item={subscriberNo.replace(/^(.{2})(.*)$/, '$1-$2')} columnWidth={widthList[0]} customClass={'semiBold'} />
                  <ColumnHtml item={mapaItem.packageName} columnWidth={widthList[1]} />
                  {/* <ColumnHtmlWithIcon
                    item={mapaItem.packageName}
                    columnWidth={widthList[1]}
                    buttonAction={() => props.getCurrentPricePlan({subscriberNo, ban})}
                  /> */}
                  <ColumnHtml item={mapaItem.customerAddress} columnWidth={widthList[2]} />
                </div>
              </>
            ) : (
              <div className='productAndServicesItemContainer_content_wrapper'>
                <ColumnTwoPartsHtml title={subscriberNo} titleCustomClass={'semiBold black'} textCustomClass={'status'}>
                  {status && <ProductStatus status={status} />}
                </ColumnTwoPartsHtml>
                <ColumnTwoPartsHtml title={'חבילה'} text={mapaItem.packageName} />
                {/* <ColumnTwoPartsHtml title={'חבילה'}>
                  <ColumnHtmlWithIcon item={mapaItem.packageName} buttonAction={() => props.getCurrentPricePlan({subscriberNo, ban})} />
                </ColumnTwoPartsHtml> */}
                <ColumnTwoPartsHtml title={'כתובת התקנה'} text={mapaItem.customerAddress} />
              </div>
            )}
          </div>
        );
      })}

      {/* MAPA KOSHER */}
      {props.mapaKosherItems?.map((mapaItem, index) => {
        const ban = mapaItem.ban;
        const subscriberNo = mapaItem.subscriberNumber;
        const status =
          mapaItem.productStatus == productStatus.BUSINESS ||
          mapaItem.productStatus == productStatus.CANCELLED ||
          mapaItem.productStatus == productStatus.SUSPENDED
            ? mapaItem.productStatus
            : null;
        return (
          <div key={index}>
            {!isMobile ? (
              <div className='productAndServicesItemContainer_content_wrapper d-flex'>
                {status && <ProductStatus status={status} />}
                <ColumnHtml item={subscriberNo.replace(/^(.{2})(.*)$/, '$1-$2')} columnWidth={widthList[0]} customClass={'semiBold'} />
                <ColumnHtmlWithIcon
                  item={mapaItem.packageName}
                  columnWidth={widthList[1]}
                  buttonAction={() => props.getCurrentPricePlan({subscriberNo, ban})}
                />
                <ColumnHtml item={mapaItem.customerAddress} columnWidth={widthList[0]} customClass={'semiBold'} />
              </div>
            ) : (
              <div className='productAndServicesItemContainer_content_wrapper'>
                <ColumnTwoPartsHtml title={subscriberNo} titleCustomClass={'semiBold black'} textCustomClass={'status'}>
                  {status && <ProductStatus status={status} />}
                </ColumnTwoPartsHtml>
                <ColumnTwoPartsHtml title={'חבילה'}>
                  <ColumnHtmlWithIcon item={mapaItem.packageName} buttonAction={() => props.getCurrentPricePlan({subscriberNo, ban})} />
                </ColumnTwoPartsHtml>
                <ColumnTwoPartsHtml title={'כתובת התקנה'} text={mapaItem.customerAddress} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MapaItem;
